import React, {
  useState,
  useRef,
  useEffect,
  useMemo,
  forwardRef,
  useImperativeHandle,
} from 'react'

import styled from 'styled-components'
import Joi from 'joi'
import toast from 'react-hot-toast'

import { StandardInput } from '../../../components/Input'

import ReCAPTCHA from '../../../components/ReCAPTCHA'

import { getFromLocalStorage } from '../../../utils/util'

const RequestorDetails = forwardRef((props, ref) => {
  const [requestorName, setRequestorName] = useState('')
  const [email, setEmail] = useState('')
  const [company, setCompany] = useState('')
  const [companyUrl, setCompanyUrl] = useState('')
  const [location, setLocation] = useState('')
  const [verified, setVerified] = useState(false)
  const [fieldErrors, setFieldErrors] = useState({})

  const captchaRef = useRef(null)

  const validationSchema = useMemo(() => {
    return Joi.object({
      requestorName: Joi.string().label('Requestor Name').required(),
      email: Joi.string()
        .label('Email')
        .email({ tlds: { allow: false } })
        .required(),
      company: Joi.string().label('Company').required(),
      companyUrl: Joi.string().label('Company Url').required(),
      location: Joi.string().label('Location').required(),
    })
  }, [])

  useEffect(() => {
    const requestorDetails = getFromLocalStorage('requestorDetails')

    if (requestorDetails) {
      setRequestorName(requestorDetails.requestorName || '')
      setEmail(requestorDetails.email || '')
      setCompany(requestorDetails.company || '')
      setCompanyUrl(requestorDetails.companyUrl || '')
      setLocation(requestorDetails.location || '')
    }
  }, [])

  const handleVerify = () => {
    setVerified(true)
  }

  const handleNext = () => {
    const formData = {
      requestorName,
      email,
      company,
      companyUrl,
      location,
    }
    const result = validationSchema.validate(formData, { abortEarly: false })

    if (result.error) {
      const validationErrors = result.error.details.reduce((acc, curr) => {
        acc[curr.context.key] = curr.message.replace(/"/g, '')
        return acc
      }, {})

      setFieldErrors(validationErrors)

      toast.error('Please fix the validation errors to continue.')

      return false
    }

    if (!verified) {
      toast.error('Please complete the CAPTCHA to continue.')

      return false
    }

    localStorage.setItem('requestorDetails', JSON.stringify(formData))

    return true
  }

  useImperativeHandle(ref, () => ({
    onNext: handleNext,
  }))

  return (
    <StyledRequestorDetails>
      <StandardInput
        title="Name"
        type="text"
        value={requestorName}
        onChange={(value) => setRequestorName(value)}
        required
        wrapperClass={fieldErrors.requestorName && 'error'}
        subText={fieldErrors.requestorName}
      />
      <StandardInput
        title="Email"
        type="text"
        value={email}
        onChange={(value) => setEmail(value)}
        required
        wrapperClass={fieldErrors.email && 'error'}
        subText={fieldErrors.email}
      />

      <StandardInput
        title="Company"
        type="text"
        value={company}
        onChange={(value) => setCompany(value)}
        required
        wrapperClass={fieldErrors.company && 'error'}
        subText={fieldErrors.company}
      />
      <StandardInput
        title="Company Website"
        type="text"
        value={companyUrl}
        onChange={(value) => setCompanyUrl(value)}
        required
        wrapperClass={fieldErrors.companyUrl && 'error'}
        subText={fieldErrors.companyUrl}
      />

      <StandardInput
        title="Location"
        type="text"
        value={location}
        onChange={(value) => setLocation(value)}
        required
        wrapperClass={fieldErrors.location && 'error'}
        subText={fieldErrors.location}
      />

      <ReCAPTCHA onChange={handleVerify} captchaRef={captchaRef} />

      {/* <div className="button__wrapper">
        <Button
          handleClick={handleNext}
          width="110px"
          height="3rem"
          radius="8px"
          btnClass="primary"
        >
          Next
        </Button>
      </div> */}
    </StyledRequestorDetails>
  )
})

const StyledRequestorDetails = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 1rem;

  .button__wrapper {
    display: flex;
    justify-content: flex-end;
    margin-top: 1rem;
  }
`

RequestorDetails.displayName = 'RequestorDetails'

export default RequestorDetails
